import { Draft } from 'immer'
import { v4 as uuidV4 } from 'uuid'
import type { NotificationMode } from '@opallabs/concepts'
import { FieldValues } from '@opallabs/satellite'
import { BlockResponse } from '../types'

type CustomFieldData =
  BlockResponse['data']['details']['custom_field_values'][number]['data']

type CreateCustomFieldValueParams = {
  fieldId: string
  value: FieldValues
  notificationMode?: NotificationMode
}

export const createCustomFieldValue = (
  params: CreateCustomFieldValueParams
) => {
  return (draftDocument: Draft<BlockResponse>) => {
    if (!draftDocument.data) return draftDocument

    const customFields = draftDocument.data.details.custom_fields
    if (!customFields) return draftDocument

    const customFieldIndex = customFields.findIndex(
      (field) => field.id === params.fieldId
    )
    if (customFieldIndex < 0) return draftDocument

    const updatedField = {
      ...customFields[customFieldIndex],
      data: params.value
        ? ({
            id: uuidV4(),
            // `FieldValues` is wider than the response schema; cast only this
            // property
            value: params.value as NonNullable<CustomFieldData>['value'],
            pending_notification_targets: { user_ids: [], group_ids: [] },
            notification_mode: params.notificationMode,
          } as Partial<NonNullable<CustomFieldData>> as CustomFieldData)
        : null,
    }

    draftDocument.data.details.custom_field_values.push(updatedField)

    return draftDocument
  }
}
